import { LineStyle, Color, LineKinds } from "../../drawing";
import { AbstractVectorItem } from "./AbstractVectorItem";
import { ILineDrawable } from "./ILineDrawable";
import { TypeKeys } from "./TypeKeys";

export class NewPageItem extends AbstractVectorItem implements ILineDrawable {
  constructor() {
    super(TypeKeys.NewPageItem);
    this.isPositionFixed = true;
  }

  public lineStyle: LineStyle = new LineStyle(new Color("#000000"), LineKinds.Dotted, 2);

  protected createCloneInstance(): NewPageItem {
    return new NewPageItem();
  }

  protected applyMembers(clone: NewPageItem): void {
    super.applyMembers(clone);
    clone.lineStyle = this.cloneValue(this.lineStyle);
  }
}
